import React from 'react';
import styled from '@emotion/styled';
import type { FlexBasisProps, JustifyContentProps } from 'styled-system';
import { flexBasis, justifyContent, space } from 'styled-system';

import DrawerFooter from 'common/components/categories/category-options/DrawerFooter';
import ClearAllFiltersButton from 'common/components/ClearAllFiltersButton';
import DrawerBody from 'common/components/Drawer/DrawerBody';
import DrawerContent from 'common/components/Drawer/DrawerContent';
import DrawerHeader from 'common/components/Drawer/DrawerHeader';
import type { SpaceProps } from 'common/theme/system-types';
import { useFilterDrawer } from '../context/FilterDrawerContext';
import FilterGroup from './FilterGroup';
import SortAccordion from './SortAccordion';

const DRAWER_BODY_PADDING = ['sp_16', 'sp_20', 'sp_24', 'sp_32'];

const ClearAllFiltersButtonStyled = styled(ClearAllFiltersButton)<
  FlexBasisProps & JustifyContentProps & SpaceProps
>`
  ${flexBasis};
  ${justifyContent};
  ${space};
`;

const CategoryFiltersDrawerContent = () => {
  const {
    headline,
    closeDrawer,
    closeDrawerWithoutHistoryBack,
    ariaLabelId,
    showSortSection,
    isSortMode,
    hideArticlesCount,
    filters,
    processedFilters,
    onFilterChange,
    defaultExpandedSections,
    sortOptions,
    currentOrder,
    applyUrl,
    hasChanges,
  } = useFilterDrawer();

  return (
    <DrawerContent>
      <DrawerHeader id={ariaLabelId} onCloseClick={closeDrawer} headline={headline} rightAlignClose>
        <ClearAllFiltersButtonStyled
          ml={[null, 'sp_8']}
          flexBasis={['44%', '30%']}
          justifyContent="flex-start"
          filters={filters}
          withTextDecoration={true}
          navigationMethod="replace"
          onNavigate={closeDrawerWithoutHistoryBack}
        />
      </DrawerHeader>

      <DrawerBody px={DRAWER_BODY_PADDING}>
        {showSortSection && (
          <SortAccordion
            sortOptions={sortOptions}
            order={currentOrder}
            onFilterChange={onFilterChange}
            isSort={isSortMode}
          />
        )}

        {processedFilters.map(({ key, type, name, ...filterGroup }) => (
          <FilterGroup
            key={key}
            type={type}
            name={name}
            filters={filterGroup.filters}
            groupKey={key}
            onFilterChange={onFilterChange}
            hideArticlesCount={hideArticlesCount ?? false}
            defaultExpandedSections={defaultExpandedSections}
          />
        ))}
      </DrawerBody>

      <DrawerFooter
        url={applyUrl}
        disabled={hasChanges}
        onNavigate={closeDrawerWithoutHistoryBack}
      />
    </DrawerContent>
  );
};

export default CategoryFiltersDrawerContent;
